/* eslint-disable max-len */
export default {
  title: "<b>Weryfikacja</b>",
  phoneSendCode: {
    description: "Aby otrzymać <span>bonus {receiverBonusAmount} zł</span> <b>podaj numer swojego telefonu komórkowego</b>",
    placeholder: "Podaj numer telefonu",
    nextButtonText: "Wyślij kod",
    genericError: "Wpisz poprawny numer telefonu",
  },
  phoneSmsConfirmation: {
    description: "Wpisz otrzymany <b>kod SMS</b>",
    details: "Kod wysłaliśmy na nr {phoneNumber}",
    placeholder: "Wpisz kod SMS",
    prevButtonText: "Popraw numer",
    nextButtonText: "Potwierdź",
    resendSmsText: "SMS nie przyszedł?",
    resendSmsButtonText: "Wyślij ponownie kod SMS",
    genericError: "Wprowadzony kod SMS jest niepoprawny",
  },
  phoneVerificationSuccess: {
    title: "Polecaj i <b>zarabiaj</b>",
    description: "Weryfikacja przebiegła pozytywnie",
    details: "Twój bonus znajduje się na koncie goodie cashback w transakcjach oczekujących. Zatwierdzimy go, gdy <b>zrobisz swoje pierwsze zakupy przez goodie cashback.</b>",
    nextButtonText: "Rozpoczynam zakupy!",
  },
  whatIsCashback: {
    title: "Czym jest <b>cashback</b>",
    subTitle: "Gdy robisz zakupy w sklepach internetowych, <b>część wydanych pieniędzy możesz otrzymać z powrotem</b> – to właśnie cashback. W goodie znajdziesz prawie 600 znanych sklepów internetowych, w których dostaniesz cashback.",
    step1Title: "Zakładasz konto w kilka sekund",
    step1Description: "Zarejestruj się w goodie cashback na stronie internetowej lub w aplikacji mobilnej goodie.",
    step2Title: "Wybierasz sklep i kupujesz",
    step2Description: "W goodie wybierz sklep i wciśnij <b>„Przejdź do sklepu”</b>, a następnie złóż zamówienie i dokonaj płatności – tak jak zawsze!",
    step3Title: "Otrzymujesz zwrot",
    step3Description: "Wysokość zwrotu znajdziesz na Twoim koncie w goodie. Po potwierdzeniu zakupu przez sklep, środki zostaną zaakceptowane do wypłaty.",
    step4Title: "Wypłacasz gotówkę na konto",
    step4Description: "<b>Po uzbieraniu min. 21 zł</b> cashbacku możesz zlecić przelew środków na dowolne konto bankowe w Polsce.",
    videoTitle: "Zobacz wideo",
  },
};
